<template>
  <div class="text-center py-8">
    <v-icon size="64" color="grey-lighten-2">{{ icon }}</v-icon>
    <h3 class="text-h6 mt-4 mb-2">{{ title }}</h3>
    <p class="text-body-2 text-grey mb-4">
      {{ description }}
    </p>
    <v-btn
      v-if="!hideButton"
      color="primary"
      rounded="lg"
      prepend-icon="mdi-plus"
      @click="onCreateClick"
    >
      {{ buttonText }}
    </v-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EmptyList',

  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: 'Crear',
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onCreateClick() {
      this.$emit('create')
    },
  },
})
</script>
